const SaveOutlined = ({ size = 16 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 16 16'
  >
    <g fill='#fff' clipPath='url(#clip0_7804_44051)'>
      <path d='M8 6.664a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333m0 4a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667' />
      <path d='M15.024 2.748 13.252.976A3.3 3.3 0 0 0 10.895 0H3.333A3.337 3.337 0 0 0 0 3.333v9.334A3.337 3.337 0 0 0 3.333 16h9.334A3.337 3.337 0 0 0 16 12.667V5.105a3.31 3.31 0 0 0-.976-2.357m-3.69-1.361V2a2 2 0 0 1-2 2H6.666a2 2 0 0 1-2-2v-.667h6.228q.223.003.438.054m3.333 11.28a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2V2a3.337 3.337 0 0 0 3.334 3.333h2.666a3.327 3.327 0 0 0 3.308-3.082l1.44 1.44c.374.376.584.884.586 1.414z' />
    </g>
    <defs>
      <clipPath id='clip0_7804_44051'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SaveOutlined;
